import styled from "styled-components";
import { Flex, FlexProps } from "../Box";

export interface FlexGapProps extends FlexProps {
   children?: import('react').ReactNode; gap?: string;
  rowGap?: string;
  columnGap?: string;
}

const FlexGap = styled(Flex)<FlexGapProps>`
  gap: ${({ gap }) => gap};
  row-gap: ${({ rowGap }) => rowGap};
  column-gap: ${({ columnGap }) => columnGap};
`;

export default FlexGap;
